module.exports = __webpack_public_path__ + "img/introducePageEight_show_five.7c5c7323.jpeg";